import { Route, Switch } from "react-router-dom";
import { Dishes } from "../Dish/Dishes";
import { MenuPage } from "./MenuPage";
import React from "react";
import { AddMenu } from "./AddMenu";
import { MenuCategory } from "./MenuCategory";
import {ModifiersPage} from "./ModifiersPage";
import {ModifierMain} from "../Modifier/ModifierMain";

export const Menu = () => {
    return (
            <Switch>
                <Route exact path="/chain/menu" component={MenuPage} />
                <Route exact path="/chain/menu/create" component={AddMenu} />
                <Route exact path="/chain/menu/:slug/edit" component={AddMenu}/>
                <Route exact path="/chain/menu/:slug/items" component={MenuCategory}/>
                <Route exact path="/chain/menu/:slug/categories" component={MenuCategory}/>
                <Route exact path="/chain/menu/:slug/modifiers" component={ModifiersPage} />
                <Route exact path="/chain/menu/:slug/modifiers/create" component={ModifierMain} />
                <Route path="/chain/menu/:slug/modifiers/:catId/edit" component={ModifierMain} />
                <Route exact path="/chain/menu/:catId/dishes/create" component={Dishes}/>
                <Route path="/chain/menu/:catId/dishes/:dishId/edit" component={Dishes}/>
            </Switch>
    );
};
